import { render, staticRenderFns } from "./Mensagem.vue?vue&type=template&id=f2deaa60"
import script from "./Mensagem.vue?vue&type=script&lang=js"
export * from "./Mensagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports